module.exports = __webpack_public_path__ + "img/radio-on.7161bc9e.svg";